import { render, staticRenderFns } from "./Furniture.vue?vue&type=template&id=24b3979c"
import script from "./Furniture.vue?vue&type=script&lang=js"
export * from "./Furniture.vue?vue&type=script&lang=js"
import style0 from "./Furniture.vue?vue&type=style&index=0&id=24b3979c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports